"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    fontFamily: `'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif`,
    fontSizeXs: '13px',
    fontSizeSm: '15px',
    fontSizeMd: '19px',
    fontSizeLg: '24px',
    fontSizeXl: '36px',
    fontSize2xl: '45px',
    fontWeightDefault: 400,
    fontWeightAttention: 600,
    fontWeightAttentionMax: 700,
    lineHeightXs: '18px',
    lineHeightSm: '24px',
    lineHeightMd: '28px',
    lineHeightLg: '32px',
    lineHeightXl: '48px',
    lineHeight2xl: '64px',
};
exports.default = typography;
